import { render, staticRenderFns } from "./coach-prove-2023.vue?vue&type=template&id=ff890724&scoped=true&"
import script from "./coach-prove-2023.vue?vue&type=script&lang=js&"
export * from "./coach-prove-2023.vue?vue&type=script&lang=js&"
import style0 from "./coach-prove-2023.vue?vue&type=style&index=0&id=ff890724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff890724",
  null
  
)

export default component.exports